import React from "react";
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import { resultStore } from "./../stores";
import Result from "../result/Result";

const AssessResult = () => {
  if (!resultStore.responses) {
    return <p style={{ textAlign: "center" }}>Nothing here.</p>;
  }
  if (resultStore.churchResponse) {
    return <Redirect to="/dashboard" />;
  }
  return (
    <Result
      questions={resultStore.responses.filter((x) => typeof x === "number")}
      phaseId={resultStore.phase.stage}
    />
  );
};

AssessResult.displayName = "AssessResult";

export default observer(AssessResult);



// WEBPACK FOOTER //
// ./src/assess/AssessResult.js